export default {
  namespaced: true,

  state: {
    order: null,
  },

  getters: {
    get: state => {
      return state.order;
    },
  },

  mutations: {
    set: (state, order) => {
      state.order = order;
    },
  },

  actions: {
    async init({commit, rootGetters}, handle) {
      commit('set', null);

      // we can get current order only from order page
      const pageType = rootGetters['shopify/page/type'];
      if (pageType !== 'order') return;

      /**
        after customer is sent to order "Thank you" page
        window.Shopify.checkout will contain order and line items data
       */
      commit('set', window.Shopify.checkout || null);

      // TODO if we want to use `/account/orders/` page we can load order via API here
    },
  },
};
